import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type RecruitingStatusFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  id: -1,
  name: '',
  status: defaultStatus,
} as RecruitingStatusFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/recruiting-statuses', name: 'Recruiting Statuses' },
];
